import { ContactWindow } from "@/components/contacts/ContactWindow";
import { contactsFilterCategory } from "@/data/filters/categories/contacts";
import type { Configuration } from "@/types/campaign";
import { createFileRoute } from "@tanstack/react-router";
import { type SetStateAction } from "jotai";
import { useCallback, useMemo } from "react";

export const Route = createFileRoute(
  "/_dashboard/campaigns/setup/define/$category/contacts",
)({
  component: RouteComponent,
  loader: () => ({
    crumb: contactsFilterCategory.title,
    meta: {
      title: contactsFilterCategory.title,
    },
  }),
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const { useNewCampaignState } = Route.useRouteContext();
  const [newCampaignState, setNewCampaignState] = useNewCampaignState();

  const configuration = useMemo(
    () => newCampaignState.configurations.find((c) => c.quality === 1),
    [newCampaignState.configurations],
  );

  const setConfiguration = useCallback(
    (value: SetStateAction<Configuration>) => {
      setNewCampaignState((prev) => ({
        ...prev,
        configurations: prev.configurations.map((c) =>
          c.quality === 1
            ? typeof value === "function"
              ? value(c)
              : value
            : c,
        ),
      }));
    },
    [setNewCampaignState],
  );

  if (!configuration) {
    navigate({ to: "/campaigns/setup/define" });
    return;
  }

  return (
    <div>
      <ContactWindow
        configuration={configuration}
        setConfiguration={setConfiguration}
        onDoneUpdating={() => navigate({ to: "/campaigns/setup/define" })}
      />
    </div>
  );
}
